export default {
	loading: 'Loading...',
	add: 'Add',
	delete: 'Delete',
	edit: 'Edit',
	query: 'Search',
	export: 'Export',
	handle: 'Action',
	back: 'Back',
	home: 'Home',
	confirm: 'Confirm',
	cancel: 'Cancel',
	clear: 'Clear',
	close: 'Close',
	createTime: 'Creation Time',
	updateTime: 'Update Time',
	required: 'Required field cannot be empty',
	app: {
		title: 'Device Lifecycle Management Platform',
		description: 'A low-threshold admin platform built with Vue3, TypeScript, Element Plus, Vue Router, Pinia, Axios, i18n, and Vite.',
		logoText: 'Device Lifecycle Management Platform',
		miniLogoText: 'MAKU',
		username: 'Username',
		password: 'Password',
		captcha: 'Captcha',
		mobileSignIn: 'Mobile Sign In',
		mobile: 'Mobile',
		signIn: 'Sign in',
		signOut: 'Sign Out',
		profile: 'Profile',
		large: 'Large',
		default: 'Default',
		small: 'Small',
		close: 'Close',
		closeOthers: 'Close Others',
		closeAll: 'Close All'
	},
	settings: {
		title: 'Layout Settings',
		sidebarDark: 'Dark Sidebar',
		sidebarLight: 'Light Sidebar',
		navbarLight: 'Light Navbar',
		navbarTheme: 'Theme Navbar',
		layout: 'Layout Switch',
		vertical: 'Vertical',
		columns: 'Columns',
		transverse: 'Transverse',
		interface: 'Interface Settings',
		uniqueOpened: 'Unique Opened',
		dark: 'Enable Dark',
		logo: 'Enable Logo',
		breadcrumb: 'Enable Breadcrumb',
		tabs: 'Enable Tabs',
		tabsCache: 'Enable Tabs Cache',
		defaultPlatform: 'Default Platform',
		platType: 'Platform Style',
		tabsStyle: 'Tabs Style',
		tips: 'After setting, it will only take effect temporarily. To take effect permanently, you need to click the "Copy Config" button below to replace the configuration in store/theme/config.ts. ',
		copyConfig: 'Copy Config',
		reset: 'Reset',
		copySuc: 'Copy Succeeded',
		style1: 'Style-1',
		style2: 'Style2',
		intelligent: 'Intelligent O&M Platform',
		lifecycle: 'Device Lifecycle',
		platTypeDefault: 'Default',
		platTypeSmart: 'Smart O&M',
		langSwitch: 'Language',
		alarmBroadcast: 'Alarm Broadcast',
		alarmQRCode: 'Alarm QR Code',
		appDownload: 'APP Download',
		aiAssistant: 'AI Assistant',
		fullscreen: 'Fullscreen/Exit Fullscreen',
		exitFullscreen: 'Fullscreen/Exit Fullscreen'
	},
	maComponents: {
		pleaseSelect: 'Please select one',
		pleaseInput: 'Please input one',
		loading: 'Loading...',
		noData: 'No Data',
		expandAll: 'Expand All',
		collapseAll: 'Collapse All',
		device: {
			selectDevice: 'Select Device',
			deviceName: 'Device Name',
			deviceType: 'Device Type',
			deviceModel: 'Device Model'
		},
		dict: {
			selectDict: 'Select Dictionary',
			dictType: 'Dictionary Type',
			dictValue: 'Dictionary Value',
			dictLabel: 'Dictionary Label'
		},
		org: {
			selectOrg: 'Select Organization',
			orgName: 'Organization Name',
			parentOrg: 'Parent Organization'
		},
		user: {
			selectUser: 'Select User',
			username: 'Username',
			realName: 'Real Name',
			mobile: 'Mobile Number',
			createTime: 'Create Time'
		},
		post: {
			selectPost: 'Select Post',
			postName: 'Post Name'
		},
		report: {
			selectReport: 'Select Report',
			reportName: 'Report Name'
		},
		address: {
			selectAddress: 'Select Address',
			province: 'Province',
			city: 'City',
			district: 'District'
		},
		icon: {
			selectIcon: 'Select Icon',
			iconName: 'Icon Name'
		}
	},
	common: {
		save: 'Save',
		reset: 'Reset',
		delete: 'Delete',
		edit: 'Edit',
		cancel: 'Cancel',
		confirm: 'Confirm',
		back: 'Back'
	},
	profile: {
		title: 'Personal Information',
		basicInfo: 'Basic Information',
		basicData: 'Basic Data',
		changePassword: 'Change Password',
		uploadAvatar: 'Upload Avatar',
		platformLogo: 'Platform Logo',
		uploadPlatformLogo: 'Upload Platform Logo',
		username: 'Username',
		realName: 'Real Name',
		mobile: 'Mobile Number',
		email: 'Email',
		wecomId: 'wecomId',
		orgName: 'Organization',
		postName: 'Position',
		createTime: 'Create Date',
		encryptPassword: 'Encrypted Password',
		currentPassword: 'Current Password',
		noData: 'No Data',
		authTitle: 'For security, please enter your current login password to view encrypted password',
		authMessage: 'Identity Verification',
		passwordRequired: 'Password cannot be empty',
		modifySuccess: 'Modified Successfully',
		gender: 'Gender',
		phonePlaceholder: 'Mobile Number',
		emailPlaceholder: 'Email',
		namePlaceholder: 'Name',
		freeLogin: 'Password-free Login',
		freeLoginTip: 'The password-free link contains an encrypted login password. Anyone with the link can log in directly, so keep it private.',
		basicParams: 'Basic Parameters',
		displayParams: 'Display Parameters',
		baseUrl: 'System URL',
		baseUrlPlaceholder: 'e.g. http://172.16.8.152:7018',
		baseUrlRequired: 'Please enter the system URL',
		usernamePlaceholder: 'Please enter the username',
		usernameRequired: 'Please enter the username',
		loginPassword: 'Login Password',
		loginPasswordPlaceholder: 'Enter the current login password to generate the encrypted password',
		loginPasswordRequired: 'Please enter the login password',
		targetPage: 'Target Page',
		targetPagePlaceholder: 'Defaults to /screen, enter another page path if needed',
		targetPageRequired: 'Please select the target page',
		showMenu: 'Show Menu',
		showMenuHint: 'Show sidebar and top navigation after opening the link (show_menu=true)',
		showSettings: 'Show Settings',
		showSettingsHint: 'Show the settings panel after opening the link (show_settings=true)',
		hiddenTree: 'Hide Left Tree',
		hiddenTreeHint: 'Hide the left tree after opening the link (is_hidden_true=true)',
		generateLink: 'Generate Link',
		generateLinkSuccess: 'Password-free link generated successfully',
		generateLinkFailed: 'Failed to generate the link, please check the parameters',
		resetLink: 'Reset',
		generatedLink: 'Generated Link',
		generatedLinkPlaceholder: 'Fill in the parameters and click "Generate Link"',
		copyLink: 'Copy Link',
		copyLinkSuccess: 'Link copied to clipboard',
		copyLinkFailed: 'Copy failed, please select and copy manually',
		openLink: 'Open Link',
		qrcode: 'QR Code',
		scanTip: 'Scan with a tablet or phone to open directly',
		oldPassword: 'Old Password',
		newPassword: 'New Password',
		confirmPassword: 'Confirm Password',
		thirdParty: {
			title: 'Third Party Login',
			serialNumber: 'Serial Number',
			platformType: 'Platform Type',
			wechatWork: 'WeChat Work',
			dingtalk: 'DingTalk',
			feishu: 'Feishu',
			wechat: 'WeChat',
			nickname: 'Nickname',
			status: 'Status',
			unbound: 'Unbound',
			bound: 'Bound',
			bind: 'Bind',
			unbind: 'Unbind',
			operationSuccess: 'Operation Successful'
		}
	},
	appDownload: {
		title: 'Mobile APP Download',
		qrcodeTip: 'Scan the QR code to download the APP',
		manualTitle: 'Operation Manual',
		manualPreview: 'Operation Manual',
		viewManual: 'View Operation Manual'
	},
	sys: {
		common: {
			batchDelete: 'Batch Delete',
			reset: 'Reset',
			platformType: 'Platform Type',
			groupName: 'Group Name',
			status: 'Status',
			pleaseSelect: 'Please Select',
			parentNode: 'Parent Node',
			pleaseSelectParent: 'Please Select Parent',
			sort: 'Sort',
			operationSuccess: 'Operation Successful',
			operationFailed: 'Operation failed, please try again'
		},
		attachment: {
			upload: 'Upload',
			batchDelete: 'Batch Delete',
			action: {
				download: 'Download',
				preview: 'Preview'
			},
			uploadFailed: 'Upload failed: ',
			uploadSuccess: 'Upload successful',
			fileTooLarge: 'File size cannot exceed 100M',
			query: {
				bizType: 'Business Type',
				name: 'Attachment Name',
				fileType: 'Attachment Type'
			},
			table: {
				name: 'Attachment Name',
				fileType: 'File Type',
				size: 'Size',
				platform: 'Storage Platform',
				bizType: 'Business Type'
			}
		},
		config: {
			sms: {
				title: 'SMS Config',
				signName: 'SMS Signature',
				templateId: 'SMS Template',
				groupNameHint: 'Configs with the same group name will send SMS in round-robin',
				url: 'Access URL',
				urlHint: 'APP access URL',
				senderIdIntlHint: 'Required for international SMS',
				channelNo: 'Channel No.',
				channelNoHint: 'Channel No. is required'
			},
			mail: {
				title: 'Mail Config',
				groupNameHint: 'Configs with the same group name will send mail in round-robin',
				mailFrom: 'Mail Account',
				mailFromPlaceholder: 'Sender email',
				mailPass: 'Mail Password',
				mailHost: 'SMTP Host',
				mailHostHint: 'Required for enterprise/self-hosted email',
				mailPort: 'SMTP Port',
				mailPortHint: 'Default is port 25',
				endpointHint: 'Aliyun endpoint'
			},
			third: {
				title: 'Third Party Login'
			}
		},
		menu: {
			expandAll: 'Expand All',
			collapseAll: 'Collapse All',
			table: {
				name: 'Name',
				icon: 'Icon',
				type: 'Type',
				openStyle: 'Open Style',
				sort: 'Sort',
				route: 'Route',
				authority: 'Authority'
			},
			type: {
				menu: 'Menu',
				button: 'Button',
				api: 'API'
			},
			openStyle: {
				internal: 'Internal',
				external: 'External'
			},
			permissionButtonConfig: 'Configure Permission Buttons',
			addPermissionButtonsTitle: 'Add Permission Buttons (CRUD)',
			submit: 'Submit',
			operationSuccess: 'Operation Successful',
			operationFailed: 'Operation failed, please try again',
			permission: {
				view: 'View',
				add: 'Add',
				edit: 'Edit',
				delete: 'Delete'
			},
			form: {
				type: 'Type',
				name: 'Name',
				parent: 'Parent Menu',
				route: 'Route',
				sort: 'Sort',
				openStyle: 'Open Style',
				display: 'Display',
				authority: 'Authority',
				authorityPlaceholder: 'Separate with commas, e.g. sys:menu:save,sys:menu:update',
				icon: 'Icon'
			},
			display: {
				show: 'Show',
				hide: 'Hide'
			}
		},
		org: {
			table: {
				name: 'Name',
				path: 'Path'
			},
			form: {
				gridLayout: 'Grid Layout',
				parentDept: 'Parent Department',
				orgPlaceholder: 'Organization',
				name: 'Name',
				leader: 'Leader'
			}
		},
		dict: {
			type: {
				query: {
					dictType: 'Dict Type',
					dictName: 'Dict Name'
				},
				table: {
					dictType: 'Dict Type',
					dictName: 'Dict Name',
					remark: 'Remark',
					source: 'Source'
				},
				source: {
					dictData: 'Dict Data',
					dynamicSql: 'Dynamic SQL'
				},
				action: {
					dictConfig: 'Dict Config',
					dynamicData: 'Dynamic Data'
				},
				drawer: {
					dictConfig: 'Dict Config',
					dynamicData: 'Dynamic Data'
				},
				form: {
					dictType: 'Dict Type',
					dictName: 'Dict Name',
					remark: 'Remark',
					source: 'Source',
					dictSql: 'Dynamic SQL',
					dictSqlPlaceholder: 'e.g. select id as dictValue, name as dictLabel from sys_role where deleted = 0'
				}
			},
			data: {
				table: {
					dictValue: 'Dict Value',
					dictLabel: 'Dict Label'
				},
				form: {
					dictValue: 'Dict Value',
					dictLabel: 'Dict Label',
					labelClass: 'Label Style',
					remark: 'Remark'
				}
			}
		},
		user: {
			import: 'Import',
			exportFile: 'Export File',
			table: {
				username: 'Username',
				realName: 'Real Name',
				gender: 'Gender',
				status: 'Status',
				mobile: 'Mobile',
				orgName: 'Organization',
				accountExpireTime: 'Account Expire Time',
				passwordExpireTime: 'Password Expire Time'
			},
			query: {
				username: 'Username',
				mobile: 'Mobile',
				gender: 'Gender',
				orgId: 'Organization'
			},
			form: {
				username: 'Username',
				realName: 'Real Name',
				gender: 'Gender',
				email: 'Email',
				mobile: 'Mobile',
				password: 'Password',
				orgId: 'Organization',
				inspectOrgId: 'Organization (Inspection)',
				roleIdList: 'Roles',
				postIdList: 'Posts',
				wechatLevel: 'WeChat Alarm Level',
				wecomLevel: 'WeCom Alarm Level',
				wechatLevelPlaceholder: 'WeChat Official Account Alarm Level',
				comchatLevelPlaceholder: 'WomChat Official Account Alarm Level',
				smsLevel: 'SMS Alarm Level',
				mailLevel: 'Mail Alarm Level',
				tokenExpireTime: 'Token Expire Time',
				tokenExpireTimePlaceholder: 'Please select token expire time',
				accountExpireTime: 'Account Expire Time',
				accountExpireTimePlaceholder: 'Please select account expire time',
				passwordExpireTime: 'Password Expire Time',
				passwordExpireTimePlaceholder: 'Please select password expire time',
				warnType: 'Push Alarm Type',
				generalWarnPushInterval: 'General Alarm Push Interval',
				mediumWarnPushInterval: 'Medium Alarm Push Interval',
				pushIntervalUnitPlaceholder: 'Unit: hour'
			},
			level: {
				normal: 'Normal',
				medium: 'Medium',
				severe: 'Severe',
				none: 'None'
			},
			validation: {
				mobileFormat: 'Please enter a valid mobile number'
			}
		}
	},
	screen: {
		empty: {
			noData: 'No data',
			noChart: 'No chart'
		},
		itemWrap: {
			loading: 'Loading...'
		},
		common: {
			timeRange: {
				last7Days: 'Last 7 days',
				last1Month: 'Last 1 month',
				last3Months: 'Last 3 months'
			},
			status: {
				running: 'Running',
				stopped: 'Stopped',
				offline: 'Offline',
				unknown: 'Unknown'
			},
			alarmLevel: {
				normal: 'Normal',
				general: 'General',
				medium: 'Medium',
				severe: 'Severe',
				emergency: 'Emergency',
				generalAlarm: 'General alarm',
				mediumAlarm: 'Medium alarm',
				severeAlarm: 'Severe alarm'
			},
			device: {
				countUnit: 'unit(s)',
				deviceCountWithUnit: 'Device count (units)',
				processPointCount: 'Process points (units)',
				warnPointCount: 'Alarm points (units)'
			}
		},
		index: {
			headerTitle: 'Intelligent Operation and Maintenance Platform',
			deviceHealthRank: 'Device health ranking',
			deviceTypeStats: 'Device type statistics',
			dailyRunStats: 'Daily device operation statistics',
			deviceAlarmStats: 'Device alarm statistics (units)',
			last7DaysAlarmHandle: 'Alarm handling in last 7 days',
			last7DaysNewAlarm: 'New alarms in last 7 days'
		},
		topc: {
			refreshTooltip: 'Refresh page data',
			profile: 'Personal center',
			alarmQrcode: 'Alarm QR code',
			appDownload: 'Download APP',
			logout: 'Logout',
			bindPhoneRequired: 'User must bind phone number first',
			warnQrcodeDialogTitle: 'Alarm notification QR code'
		},
		contentCenter: {
			mapMode: 'Map mode',
			deviceMode: 'Device mode',
			mapConfig: 'Map configuration',
			noDeviceData: 'No device data',
			pauseAutoPlay: 'Pause auto play',
			startAutoPlay: 'Start auto play',
			mapJson: 'Map JSON',
			uploadJson: 'Click to upload',
			mapPointInfo: 'Map point information',
			selectDept: 'Select department',
			pointName: 'Point name',
			pointNamePlaceholder: 'Please enter point name',
			longitude: 'Longitude',
			longitudePlaceholder: 'Please enter longitude',
			latitude: 'Latitude',
			latitudePlaceholder: 'Please enter latitude',
			addPoint: 'Add point',
			cancel: 'Cancel',
			saveConfig: 'Save configuration',
			saveSuccess: 'Map configuration saved successfully',
			saveFailed: 'Please check if the form is filled correctly',
			runningStatusTitle: 'Device operation status',
			columnIndex: 'Number',
			columnDeviceName: 'Device name',
			columnDeviceNumber: 'Device number',
			columnStatus: 'Operation status',
			columnDuration: 'Duration',
			columnAlarmLevel: 'Alarm level',
			descriptionPrefix: 'Device type: '
		},
		leftTop: {
			deviceCountSeriesName: 'Device count'
		},
		leftCenter: {
			totalLabel: 'Total',
			tooltipUnit: 'units',
			seriesName: 'Device type statistics'
		},
		leftBottom: {
			seriesRun: 'Running',
			seriesStop: 'Stopped',
			seriesOffline: 'Offline'
		},
		rightTop: {
			levelSevere: 'Severe',
			levelMedium: 'Medium',
			levelGeneral: 'General',
			levelNormal: 'Normal',
			levelEmergency: 'Emergency'
		},
		rightCenter: {
			handledAlarm: 'Handled alarms',
			pendingAlarm: 'Pending alarms'
		},
		rightBottom: {
			levelSevere: 'Severe',
			levelMedium: 'Medium',
			levelGeneral: 'General'
		},
		factoryDetails: {
			selectFactory: 'Select factory',
			totalAlarm: 'Total alarms',
			totalDevice: 'Total devices',
			totalSensor: 'Total sensors',
			totalOrder: 'Total orders',
			recentAlarm: 'Recent alarms',
			noAlarm: 'No alarms',
			uploadFactoryImage: 'Upload factory image',
			savePosition: 'Save position',
			editPosition: 'Edit position',
			dragTip: 'Drag the marker area to adjust position',
			deviceCount: 'Device count',
			alarmCount: 'Alarm count',
			orderCount: 'Order count',
			saveSuccess: 'Saved successfully',
			saveFailed: 'Save failed'
		},
		weather: {
			defaultWeather: 'Sunny'
		}
	},
	designForm: {
		widgetLibrary: 'Widget Library',
		formDesign: 'Form Design',
		formConfig: 'Form Config',
		fieldSettings: 'Field Settings',
		add: 'Add',
		delete: 'Delete',
		copy: 'Copy',
		moveUp: 'Move Up',
		moveDown: 'Move Down',
		label: 'Label',
		placeholder: 'Placeholder',
		required: 'Required',
		defaultValue: 'Default Value',
		hint: 'Hint',
		validation: 'Validation',
		width: 'Width',
		height: 'Height',
		precision: 'Precision',
		min: 'Min',
		max: 'Max',
		format: 'Format',
		multiple: 'Multiple',
		clearable: 'Clearable',
		filterable: 'Filterable',
		options: 'Options',
		optionValue: 'Value',
		optionLabel: 'Label',
		addOption: 'Add Option',
		save: 'Save',
		cancel: 'Cancel',
		reset: 'Reset',
		preview: 'Preview',
		generateCode: 'Generate Code',
		jsonEditor: 'JSON Editor',
		import: 'Import',
		emptyWidget: 'No widget selected',
		fieldKey: 'Field Key',
		title: 'Title',
		staticData: 'Static Data',
		varAssign: 'Variable Binding',
		dictData: 'Dictionary',
		setOptionValue: 'Set Option Value',
		varName: 'Variable Name',
		dictKey: 'Dictionary Key',
		buttonStyle: 'Button Style',
		opProps: 'Operation Properties',
		readonly: 'Readonly',
		disabled: 'Disabled',
		clear: 'Clearable',
		hideLabel: 'Hide Label',
		showPassword: 'Show Password',
		showWordLimit: 'Show Word Limit',
		validate: 'Validation',
		customError: 'Custom error message',
		string: 'String',
		url: 'URL',
		email: 'Email',
		pattern: 'Regex',
		patternPlaceholder: 'Enter a regular expression',
		designerTitle: 'MAKU - Form Designer',
		importJson: 'Import JSON',
		generateJson: 'Generate JSON',
		clickUpload: 'Click to upload',
		dragTip: 'Drag from the left to add a field',
		widgetTypes: {
			input: 'Input',
			textarea: 'Textarea',
			number: 'Number Input',
			select: 'Select',
			radio: 'Radio',
			checkbox: 'Checkbox',
			switch: 'Switch',
			date: 'Date Picker',
			time: 'Time Picker',
			rating: 'Rating',
			slider: 'Slider',
			editor: 'Rich Text Editor',
			upload: 'Upload',
			cascader: 'Cascader',
			treeSelect: 'Tree Select',
			divider: 'Divider',
			text: 'Text'
		}
	},
	charts: {
		loading: 'Loading chart...',
		noData: 'No data',
		export: 'Export',
		refresh: 'Refresh',
		fullscreen: 'Fullscreen',
		settings: 'Settings',
		dataZoom: 'Data Zoom',
		restore: 'Restore',
		peakCount: {
			title: 'Peak Statistics',
			index: 'Index',
			frequency: 'Frequency (Hz)',
			amplitude: 'Amplitude'
		}
	},
	framework: {
		common: {
			tip: 'Tip',
			operationSuccess: 'Operation successful',
			operationFailed: 'Operation failed',
			all: 'All',
			detail: 'Details',
			ignore: 'Ignore',
			setting: 'Settings'
		},
		notifications: {
			unread: 'Unread messages',
			unreadInfo: 'Unread Messages',
			initiator: 'Initiator',
			content: 'Content',
			confirmIgnore: 'Are you sure you want to ignore this?',
			source: 'Source: ',
			time: 'Time: '
		},
		tenant: {
			title: 'Switch Tenant',
			tenantId: 'Tenant ID',
			tenantName: 'Tenant Name',
			status: 'Status',
			query: 'Search',
			pleaseSelect: 'Please select the tenant to switch to'
		},
		theme: {
			light: 'Light Theme',
			dark: 'Dark Theme',
			blue: 'Blue Theme',
			blueX: 'BlueX Theme',
			sidebarDeepBlue: 'Deep Blue Sidebar',
			navbarDeepBlue: 'Deep Blue Navbar'
		},
		navbar: {
			menuSearch: 'Search Menu'
		},
		loginTimeout: {
			message: 'Login timed out, please log in again',
			relogin: 'Log in Again'
		},
		validation: {
			email: 'Invalid email format',
			passwordMinLength: 'Password must be at least 8 characters',
			passwordStrength: 'Password must contain uppercase and lowercase letters, numbers and symbols',
			mobile: 'Invalid mobile number format'
		},
		alarmMode: {
			title: 'Alarm Broadcast Mode',
			placeholder: 'Select alarm broadcast mode',
			none: 'No broadcast',
			newOnly: 'Broadcast new alarms',
			loop: 'Broadcast in loop'
		},
		ai: {
			deepThinking: 'Deep Thinking',
			modelGeneral: 'General Diagnosis LLM',
			modelVertical: 'PHM Vertical LLM'
		},
		chart: {
			resetZoom: 'Reset',
			drag: 'Drag'
		},
		upload: {
			tip: 'Notice',
			invalidImageType: 'The uploaded image format is not supported!',
			imageSizeLimit: 'The uploaded image size cannot exceed {size}MB!'
		},
		passwordExpire: {
			title: 'Password Expired',
			message: 'Your password has expired (not updated for more than 90 days). For account security, please change your password and log in again immediately.',
			modifying: 'Updating...',
			confirm: 'Confirm Change'
		},
		routeTitle: {
			device3d: '3D Digital Panel',
			deviceDetail: 'Device Details',
			factoryDetail: 'Factory Details',
			deviceAnnotation: 'Device Annotation',
			profile: 'Profile',
			onlineForm: 'Online Form',
			onlineReport: 'Online Report',
			deviceList: 'Device List'
		}
	},
	login: {
		welcome: 'Welcome',
		usernamePlaceholder: 'Enter username',
		passwordPlaceholder: 'Enter password',
		remember: 'Remember username and password',
		selectPlatform: 'Select the platform to enter',
		bindTotp: 'Bind Two-Factor Authentication',
		totp: 'Two-Factor Authentication',
		totpScanStep: 'Step 1: Scan the QR code',
		totpScanTip: 'Scan the QR code below with a TOTP authenticator:',
		totpCodeStep: 'Step 2: Enter the dynamic code',
		totpCodeStepVerify: 'Enter the dynamic code',
		totpCodeTip: 'Please enter the 6-digit dynamic code shown in your authenticator:',
		totpCodeTipVerify: 'Please enter your two-factor authentication dynamic code:',
		totpCodePlaceholder: 'Please enter the 6-digit code',
		verifying: 'Verifying...',
		verifyAndLogin: 'Verify and Log In',
		verifyLogin: 'Verify and Log In',
		usernamePasswordRequired: 'Please enter username and password',
		accountExpired: 'The account has expired, please contact the relevant person to renew it',
		totpInitFailed: 'Failed to initialize two-factor authentication',
		totpCodeRequired: 'Please enter the 6-digit dynamic code',
		totpVerifySuccess: 'Two-factor authentication verified successfully',
		totpCanceled: 'Two-factor authentication canceled, please log in again',
		passwordChanged: 'Password changed successfully, please log in with the new password',
		passwordChangeCanceled: 'Password change canceled',
		imageBase: 'Base',
		imageLine: 'Divider',
		imageUser: 'User icon',
		imagePassword: 'Password icon'
	}
}
